import {useCallback, useEffect} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSavedContentGeneralAlert} from 'src/openapi/admin/apis/SavedContentAlertApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    ids: (string | number)[],
};

export const useGetSavedContentGeneralAlert = ({ids}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        return apiDispatch(
            getSavedContentGeneralAlert({requestBody: ids.map(id => String(id))}),
        );
    }, [ids, apiDispatch]);

    const {data, isLoading, loadData, loadingError} = useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
        shouldLoadData: false,
    });

    useEffect(() => {
        if (ids.length) {
            loadData();
        }
    }, [ids, loadData]);

    return {data, isLoading, load: loadData, loadingError};
};
